import React from 'react';
import RestaurantDetailsPage from './Page';
import { RestaurantProvider } from 'providers';

export default function RestaurantDetails(props) {
  return (
    <RestaurantProvider>
      <RestaurantDetailsPage {...props} />
    </RestaurantProvider>
  );
}
